import { Injectable } from '@angular/core';
import {AlertController, LoadingController} from '@ionic/angular';
import {EmailquoteService} from './emailquote.service';
import {AlertService} from '../common/alert.service';

@Injectable({
  providedIn: 'root'
})
export class EmailPromptService {

  constructor(private alertController: AlertController,
              private alertService: AlertService,
              private emailQuoteService: EmailquoteService,
              private loadingController: LoadingController) {  }

  async confirmSend(quoteID) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Email Quote.',
      message: 'You will no longer be able to edit this quote once it has been emailed.',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary'
        }, {
          text: 'Okay',
          handler: () => {
             return this.emailQuote(quoteID);
          }
        }
      ]
    });
    await alert.present();
  }

  async emailQuote(quoteID){
    const  quoteData = {
      quote_id : quoteID
    };

    const loading = await this.loadingController.create();
    await loading.present();

    this.emailQuoteService.sendQuote(quoteData).subscribe(
        async (res) => {
          await loading.dismiss();
          await this.alertService.presentToast('Quote Sent', false);
          return;
        }, error => {
          loading.dismiss();
          this.alertService.errorAlert('Error Sending Quote', error.error.errors, false);
          return;
        }
    );
  }
}

